let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hpq4P")).then(() => parcelRequire('hy5e4'));